module.exports = __webpack_public_path__ + "assets/calendar.1888f99b.svg";